export const Unauthorized = "UNAUTHORIZED"
export const Cancelled = "CANCELLED"